import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/data/content";
import { Reveal } from "@/components/site/reveal";

export default function ValueProp() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="advantage" ref={ref} className="bg-bone py-24 md:py-32" data-testid="value-prop-section">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2 lg:px-10">
        {/* Image, clipped frame with tilt */}
        <Reveal className="order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -left-4 -top-4 h-full w-full border border-gold/40" />
            <motion.div style={{ y }} className="relative aspect-[4/5] overflow-hidden">
              <img src={IMAGES.valueProp} alt="Premium managed property interior" className="h-full w-full object-cover" />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/10" />
            </motion.div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">The In-House Advantage</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl md:text-6xl">
              Everything<br />Under One Roof
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-lg text-base leading-relaxed text-navy/65 md:text-lg">
              Unlike standard agencies that rely on unpredictable subcontractors, we deploy our own
              dedicated in-house cleaning and maintenance specialists. One team, one point of contact,
              complete peace of mind.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 flex gap-10">
              {[
                { k: "1", v: "Dedicated team" },
                { k: "0", v: "Subcontractors" },
                { k: "360\u00B0", v: "Accountability" },
              ].map((s) => (
                <div key={s.v}>
                  <div className="font-serif text-4xl text-navy">{s.k}</div>
                  <div className="mt-1 text-xs uppercase tracking-[0.2em] text-navy/50">{s.v}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
